import React from "react";
import { useLang } from "@/contexts/LanguageContext";
import { ArrowRight, Loader2 } from "lucide-react";

export const QuickRangePanel = ({ quickRange, quickLoading, onQuickRange, step1Valid, onNext }) => {
  const { t, lang } = useLang();
  const locale = lang === "it" ? "it-IT" : "en-US";

  if (!quickRange) {
    return (
      <div className="lg:col-span-12">
        <div className="border border-black bg-white p-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div>
            <span className="overline text-[#002FA7]">{t.valuator.quick_range_title}</span>
            <p className="text-sm text-[#4A4A4A] mt-1">{t.valuator.quick_range_note}</p>
          </div>
          <button
            type="button"
            data-testid="quick-range-btn"
            onClick={onQuickRange}
            disabled={!step1Valid || quickLoading}
            className="hidden lg:inline-flex items-center gap-2 bg-[#0A0A0A] text-white px-6 py-3 font-display font-black tracking-tight border-2 border-[#0A0A0A] hover:bg-[#002FA7] hover:border-[#002FA7] transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex-shrink-0"
          >
            {quickLoading ? (<><Loader2 size={18} className="animate-spin" /> {t.valuator.quick_range_loading}</>) : (<>{t.valuator.quick_range_btn} <ArrowRight size={18} /></>)}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="lg:col-span-12">
      <div data-testid="quick-range-card" className="border border-black bg-[#0A0A0A] text-white p-8">
        <span className="overline text-[#FFCC00]">{t.valuator.quick_range_title}</span>
        <div className="mt-3 flex flex-wrap items-end gap-3">
          <span data-testid="quick-range-low" className="font-display font-black text-4xl sm:text-5xl tracking-tighter">
            €{Number(quickRange.range_low).toLocaleString(locale, { maximumFractionDigits: 0 })}
          </span>
          <span className="font-display font-black text-3xl text-[#737373]">—</span>
          <span data-testid="quick-range-high" className="font-display font-black text-4xl sm:text-5xl tracking-tighter">
            €{Number(quickRange.range_high).toLocaleString(locale, { maximumFractionDigits: 0 })}
          </span>
        </div>
        <p className="text-sm text-[#A0A0A0] mt-3 max-w-2xl">{t.valuator.quick_range_note}</p>
        <button
          type="button"
          data-testid="goto-step-2"
          onClick={onNext}
          className="mt-6 hidden lg:inline-flex items-center gap-2 bg-[#FFCC00] text-black px-6 py-3 font-display font-black tracking-tight hover:bg-white transition-colors"
        >
          {t.valuator.more_precise} <ArrowRight size={18} />
        </button>
      </div>
    </div>
  );
};

export default QuickRangePanel;
